module.exports = "img/icons-people.af03c4c.svg";